export default "__VITE_ASSET__CZteAXct__"